import { render } from "./Scripts.vue?vue&type=template&id=f57ddfd4"
import script from "./Scripts.vue?vue&type=script&lang=js"
export * from "./Scripts.vue?vue&type=script&lang=js"
script.render = render

export default script